import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Ajoute automatiquement "Authorization: Bearer <jeton>" a chaque requete vers le backend
// (le serveur ignore cet en-tete pour les routes publiques). Si le serveur repond 401
// (jeton absent/expire/invalide), on deconnecte proprement et on renvoie vers la connexion,
// plutot que de laisser l'admin face a un ecran qui ne repond plus.
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getToken();

    const requeteAvecJeton = token
      ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : request;

    return next.handle(requeteAvecJeton).pipe(
      catchError(erreur => {
        if (erreur.status === 401 && this.authService.estConnecte()) {
          this.authService.logout();
          this.router.navigate(['/admin/login']);
        }
        return throwError(() => erreur);
      })
    );
  }
}
